import React, {useState} from 'react';
import { Card, CardBody, CardTitle, Col, FormGroup, Input, Label, Row, Button } from 'reactstrap';

import SelectGeneric from "../../../components/select/selectGeneric";
import {FORM, YES_CONTINUE} from "../../../components/i18n/i18n";
import {
    FL_CAMPAIGN, FL_CATEGORY, FL_FILE, FL_NAME, FL_STATUS, FL_SUB_CATEGORY, FL_UDN,
} from "../../../components/i18n/formLabels";

import {udnProvider} from "../../../providers/udnProvider";
import {campaignProvider} from "../../../providers/xtorage/campaignProvider";
import { xtorageCategoryProvider } from "../../../providers/xtorage/categoryProvider";
import Switch from "react-bootstrap-switch";

export default function XtorageFileForm (props) {
    //const { editMode, disableInputs, domainObject } = props.formProps;


    const [file, setFile] = useState( '' )
    const [fileName, setFileName] = useState( null )

    const [status, setStatus] = useState( true);
    const [udnId, setUdnId] = useState( null);
    const [categoryId, setCategoryId] = useState( null);
    const [campaignId, setCampaignId] = useState( null);
    const [subCategoryId, setSubCategoryId] = useState( null);

    const [resetValue, setResetvalue] = useState(false)

    const onClick = (data, _) => {
        const formData = new FormData();
        formData.set('name', fileName);
        formData.set('status', status);
        formData.set('file', file );

        if (udnId !== null)
            formData.set('udn', udnId  );
        if (categoryId !== null)
            formData.set('category',  categoryId  );
        if (subCategoryId !== null)
            formData.set('subCategory',  subCategoryId  );
        if (campaignId !== null)
            formData.set('campaign',  campaignId  );


        props.save(formData);
        props.onClose()
    };

    const onFileSelect = (_file, _fileName) => {
        if(_file){
            setFileName( _fileName )
            setFile( _file )
        }
    }

    return (
        <Card>
            <CardBody tag="h4" className="border-bottom p-3 mb-0 text-xtorage">
                <i className="fas fa-plus mr-2"/>Cargar nuevo archivo
            </CardBody>
            <CardBody className="text-xtorage">
                <Row>
                    <Col md="12">
                    <FormGroup>
                            <Label>{ FL_FILE }</Label>
                            <div className="custom-file">
                                <Input
                                    type="file"
                                    name="file"
                                    className="custom-file-input"
                                    accept="*/*"
                                    onChange={ e => onFileSelect(e.target.files[0], e.target.value) }
                                />
                                <label className="custom-file-label is-invalid" htmlFor="inputGroupFile01">{fileName ? fileName :'Elegir archivo'}</label>
                            </div>
                        </FormGroup>
                    </Col>
                    <Col md="6">
                        <FormGroup>
                            <Label>{ FL_UDN }</Label>
                            <SelectGeneric
                                initialValue={ udnId }
                                setExternalValue={ value => setUdnId( value ) }
                                isDisabled={ false }
                                provider = { udnProvider }
                                resetValue={ resetValue }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="6">
                        <FormGroup>
                            <Label>{ FL_CAMPAIGN }</Label>
                            <SelectGeneric
                                initialValue={ campaignId }
                                setExternalValue={ value => setCampaignId( value ) }
                                isDisabled={ false }
                                provider = { campaignProvider }
                                resetValue={ resetValue }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="6">
                        <FormGroup>
                            <Label>{ FL_CATEGORY }</Label>
                            <SelectGeneric
                                initialValue={ categoryId }
                                setExternalValue={ value => setCategoryId( value ) }
                                isDisabled={ false }
                                provider = { xtorageCategoryProvider }
                                resetValue={ resetValue }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="6">
                        <FormGroup>
                            <Label>{ FL_SUB_CATEGORY }</Label>
                            <SelectGeneric
                                initialValue={ subCategoryId }
                                setExternalValue={ value => setSubCategoryId( value ) }
                                isDisabled={ false }
                                provider = { xtorageCategoryProvider }
                                resetValue={ resetValue }
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row className="flex justify-content-end mt-2">
                    <Button className="mx-2 w-25 rounded-pill" onClick={onClick} style={{backgroundColor: '#00C2FF', border: 'none'}}>
                        { YES_CONTINUE }
                    </Button>
                </Row>
            </CardBody>
        </Card>
    )
}
